import React from "react";
import { Link } from "react-router-dom";
import SignInPresenter from "./SignInPresenter";
import { signInUseCase } from "../../usecases/user";
import { Button } from "nq-component";
import BasePage from "../../base/BasePage";
import withRouter from "../../withRouter";
import InputFactory from "../../components/InputFactory";
import "./SignIn.scss";

class SignInPage extends BasePage {
  constructor() {
    super();
    this.presenter = new SignInPresenter(this, signInUseCase());
    this.state = { progress: false };
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit();
  }

  getMasterKey() {
    return this.props.params && this.props.params.masterKey;
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  render() {
    return (
      <div className="vh-100 signin-page">
        <div className="d-flex h-100">
          <div className="m-auto container-fluid p-0">
            <div className="row g-0 h-100">
              {/* Left Side - Brand Section */}
              <div className="col-lg-6 d-none d-lg-flex signin-brand-section">
                <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center p-5 position-relative">
                  <div className="signin-brand-overlay"></div>
                  <div className="text-center position-relative z-index-1">
                    <img
                      className="img-fluid signin-logo mb-4"
                      alt="Figaro Coffee Group"
                      src="/figaro.png"
                      style={{ maxWidth: "320px" }}
                    />
                    <h1 className="display-4 fw-bold text-white mb-3 signin-title">
                      ADMIN-BI
                    </h1>
                    <p className="text-white-50 fs-5 mb-0">
                      Business Intelligence Dashboard
                    </p>
                    <div className="signin-decorative-line mt-4"></div>
                  </div>
                </div>
              </div>

              {/* Right Side - Login Form */}
              <div className="col-lg-6 d-flex align-items-center justify-content-center bg-white">
                <div className="signin-form-container w-100 p-4 p-lg-5">
                  <div className="text-center mb-4 d-lg-none">
                    <img
                      className="img-fluid mb-3"
                      alt="Figaro Coffee Group"
                      src="/figaro.png"
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                  
                  <div className="signin-form-content">
                    <div className="mb-4">
                      <h2 className="fw-bold mb-2 signin-welcome">Welcome Back</h2>
                      <p className="text-muted">Sign in to access your dashboard</p>
                    </div>

                    <form onSubmit={this.formSubmit.bind(this)}>
                      <div className="mb-4">
                        <label className="form-label fw-semibold text-dark">
                          Email Address
                        </label>
                        <div className="signin-input-wrapper">
                          <svg className="signin-input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path>
                            <polyline points="22,6 12,13 2,6"></polyline>
                          </svg>
                          <InputFactory
                            required
                            type="Email"
                            autoComplete="nope"
                            className="form-control form-control-lg signin-input signin-input-with-icon"
                            placeholder="Enter your email"
                            field="username"
                            onChange={this.onChange.bind(this)}
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <label className="form-label fw-semibold text-dark">
                          Password
                        </label>
                        <div className="signin-input-wrapper">
                          <svg className="signin-input-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                          </svg>
                          <InputFactory
                            type="Password"
                            required
                            className="form-control form-control-lg signin-input signin-input-with-icon"
                            placeholder="Enter your password"
                            field="password"
                            onChange={this.onChange.bind(this)}
                          />
                        </div>
                      </div>

                      {/* <div className="text-end mb-4">
                        <Link to="/forgot" className="text-decoration-none signin-link">
                          Forgot password?
                        </Link>
                      </div> */}

                      <Button
                        progress={this.state.progress}
                        type="submit"
                        className="btn btn-lg w-100 signin-button fw-semibold"
                      >
                        {this.state.progress ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Signing in...
                          </>
                        ) : (
                          "Sign In"
                        )}
                      </Button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignInPage);
